import { checkauth } from '../Helper';

const CatalogCheck = () => import('../views/catalogcheck/Index.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [{ path: '/catalog-check', name: 'catalogcheck', component: CatalogCheck, beforeEnter: guard }];
